// src/components/login/login.js
import React, { useEffect, useRef } from "react";
import MainAppBar from "../topBar/appBar";
import Logo from "../topBar/logo";
import Container from "@mui/material/Container";

import { useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import { loginRequest } from "../../authConfig";

export default function Login() {
  const { instance, inProgress } = useMsal();
  const started = useRef(false);

  useEffect(() => {
    const run = async () => {
      if (inProgress !== InteractionStatus.None) return;
      if (started.current) return;
      started.current = true;

      await instance.loginRedirect(loginRequest);
    };
    run();
  }, [instance, inProgress]);

  return (
    <div>
      <MainAppBar>
        <Container
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            height: "100px",
          }}
        >
          <Logo />
        </Container>
      </MainAppBar>

      <Container
        style={{
          marginTop: "50px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <h3>Redirecting to Microsoft Entra sign-in...</h3>
      </Container>
    </div>
  );
}
